import countries from '../../data/countries.json'

function fill(select) {
    if (select.dataset.countries === '1') return
    const placeholder = [...select.options].find((option) => option.value === '')
    const blank = document.createElement('option')
    blank.value = ''
    blank.textContent = placeholder ? placeholder.textContent : ''
    select.replaceChildren(blank)
    countries.forEach((name) => {
        const option = document.createElement('option')
        option.value = name
        option.textContent = name
        select.append(option)
    })
    select.dataset.countries = '1'
}

function scan(root) {
    root.querySelectorAll('select[name="country"]').forEach(fill)
}

export default function countrySelects() {
    scan(document)
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType !== 1) return
                if (node.matches('select[name="country"]')) fill(node)
                scan(node)
            })
        })
    })
    observer.observe(document.body, { childList: true, subtree: true })
}
